export const API_READ_ELIGIBILITY_ASSESSMENTS =
  'GET_ELIGIBILITY_ASSESSMENTS' as const;
export const API_READ_ELIGIBILITY_ASSESSMENTS_SUCCESS =
  'GET_ELIGIBILITY_ASSESSMENTS_SUCCESS' as const;
export const API_READ_ELIGIBILITY_ASSESSMENTS_FAILURE =
  'GET_ELIGIBILITY_ASSESSMENTS_FAILURE' as const;
